import { useState } from 'react';

// Ngày giờ ngắn: "19/09 07:28".
export const fmtTaskDate = (d) => {
  if (!d) return '';
  const dt = new Date(d);
  const p = (n) => String(n).padStart(2, '0');
  return `${p(dt.getDate())}/${p(dt.getMonth() + 1)} ${p(dt.getHours())}:${p(dt.getMinutes())}`;
};
// Thời gian hoàn thành (ms) -> chữ gọn: "45 phút", "2 giờ 15 phút", "3 ngày 4 giờ".
export const fmtTaskDuration = (ms) => {
  const n = Number(ms);
  if (!n || n < 0) return 'dưới 1 phút';
  const mins = Math.floor(n / 60000);
  if (mins < 1) return 'dưới 1 phút';
  if (mins < 60) return `${mins} phút`;
  const hours = Math.floor(mins / 60);
  const m = mins % 60;
  if (hours < 24) return m ? `${hours} giờ ${m} phút` : `${hours} giờ`;
  const days = Math.floor(hours / 24);
  const h = hours % 24;
  return h ? `${days} ngày ${h} giờ` : `${days} ngày`;
};

export const openTaskCount = (tasks) => (tasks || []).filter((t) => !t.done).length;
export const taskAssigneeIds = (t) => (t.assignees && t.assignees.length ? t.assignees : (t.assignee ? [t.assignee] : [])).map(String);

// Thân mục CÔNG VIỆC dùng CHUNG cho: bảng thông tin ChatPage (desktop), khung chat nổi & MOBILE
// (ChatWidget/CustomerChat) và trang tổng hợp Công việc. Tự quản ô tạo việc + bộ lọc "chưa xong".
// Backend ĐÃ lọc quyền xem theo phòng ban -> việc nào hiện ở đây thì người xem đều thao tác (tiếp
// nhận/hoàn thành HỘ) được. `hideCreate` để ẩn nút tạo (trang tổng hợp không tạo việc trực tiếp).
export default function ChatTasksPanel({ tasks, assigneeOptions, me, onCreate, onAccept, onComplete, onDelete, initialMsg, hideCreate, onOpenConv }) {
  const [adding, setAdding] = useState(false);
  const [content, setContent] = useState(() => (initialMsg?.text || '').slice(0, 500));
  const [assignees, setAssignees] = useState(() => new Set()); // ĐA NGƯỜI NHẬN: 1 việc chung, tích nhiều người
  const [busy, setBusy] = useState(false);
  const [onlyOpen, setOnlyOpen] = useState(false); // bộ lọc: chỉ hiện việc CHƯA hoàn thành
  const myId = String(me?.id || me?._id || '');
  const isBoss = me?.role === 'GD' || me?.role === 'CV';
  const list = tasks || [];
  const openCnt = list.filter((t) => !t.done).length;
  const shown = onlyOpen ? list.filter((t) => !t.done) : list;
  const toggleAssignee = (id) => setAssignees((prev) => { const n = new Set(prev); const k = String(id); if (n.has(k)) n.delete(k); else n.add(k); return n; });

  async function submit() {
    const text = content.trim();
    if (!text) { window.alert('Nhập nội dung công việc'); return; }
    if (!assignees.size) { window.alert('Chọn ít nhất 1 người thực hiện'); return; }
    setBusy(true);
    try {
      await onCreate({ content: text, assignees: [...assignees] });
      setContent(''); setAssignees(new Set()); setAdding(false);
    } catch (e) { window.alert(e?.response?.data?.message || 'Tạo công việc thất bại'); }
    finally { setBusy(false); }
  }

  return (
    <div className="chattask-body">
      {!hideCreate && !adding && (
        <button type="button" className="chattask-add" onClick={() => setAdding(true)}>＋ Tạo công việc</button>
      )}
      {adding && (
        <div className="chattask-form">
          <textarea className="chat-input" rows={2} value={content} onChange={(e) => setContent(e.target.value)} placeholder="Nội dung công việc…" autoFocus />
          <div className="small muted" style={{ margin: '2px 0 4px' }}>Giao cho (chọn 1 hoặc nhiều người) · đã chọn {assignees.size}</div>
          <div style={{ maxHeight: 160, overflowY: 'auto', border: '1px solid var(--border)', borderRadius: 8 }}>
            {(assigneeOptions || []).map((o, i) => (
              <label key={o.id} style={{ display: 'flex', gap: 8, alignItems: 'center', padding: '6px 8px', cursor: 'pointer', fontWeight: 400, borderTop: i ? '1px solid var(--line)' : 'none' }}>
                <input type="checkbox" checked={assignees.has(String(o.id))} onChange={() => toggleAssignee(o.id)} style={{ width: 'auto' }} />
                <span>{o.name}{String(o.id) === myId ? ' (bạn)' : ''}</span>
              </label>
            ))}
          </div>
          <div className="chattask-form-actions">
            <button type="button" className="btn sm ghost" onClick={() => { setAdding(false); setContent(''); setAssignees(new Set()); }}>Huỷ</button>
            <button type="button" className="btn sm" disabled={busy} onClick={submit}>＋ Tạo công việc</button>
          </div>
        </div>
      )}
      {/* Bộ lọc: chỉ hiện việc chưa hoàn thành (việc đã xong tự xuống dưới cùng của list). */}
      {list.length > 0 && (
        <button type="button" className={'chattask-filter' + (onlyOpen ? ' on' : '')} onClick={() => setOnlyOpen((v) => !v)}>
          {onlyOpen ? '☑' : '☐'} Chỉ hiện chưa hoàn thành{openCnt ? ` (${openCnt})` : ''}
        </button>
      )}
      {!shown.length && !adding && (
        <div className="small muted" style={{ marginTop: 6 }}>{onlyOpen && list.length ? 'Tất cả đã hoàn thành 🎉' : 'Chưa có công việc nào.'}</div>
      )}
      {shown.map((t) => {
        const assigneeIds = taskAssigneeIds(t);
        const names = (t.assigneeNames && t.assigneeNames.length ? t.assigneeNames : (t.assigneeName ? [t.assigneeName] : []));
        const doneMap = new Map((t.doneBy || []).map((x) => [String(x.user), x]));
        const people = assigneeIds.map((id, i) => { const d = doneMap.get(id); return { id, name: names[i] || '', done: !!d, proxyName: d?.proxyName || '' }; });
        const doneCount = people.filter((p) => p.done).length;
        const total = people.length;
        const isAssignee = assigneeIds.includes(myId);
        const iMDone = doneMap.has(myId);
        const canDel = myId === String(t.creator) || isBoss;
        return (
          <div key={t.id} className={'chattask' + (t.done ? ' done' : t.accepted ? ' accepted' : '')}>
            <div className="chattask-content">{t.content}</div>
            <div className="chattask-meta">
              <span>Người tạo: <b>{t.creatorName}</b></span>
              <span className="chattask-date">{fmtTaskDate(t.createdAt)}</span>
              {t.conv?.name && (onOpenConv
                ? <button type="button" className="chattask-openconv" onClick={() => onOpenConv(t)} title="Mở đoạn chat">💬 {t.conv.name} ↗</button>
                : <span>· {t.conv.name}</span>)}
            </div>
            {/* TIẾN ĐỘ theo TỪNG người: ✓ = đã xong phần mình, ○ = chưa; "(… làm hộ)" nếu người khác làm giúp. */}
            <div style={{ margin: '5px 0', fontSize: 12 }}>
              <b style={{ color: t.done ? 'var(--ok)' : 'var(--accent)' }}>Hoàn thành {doneCount}/{total}</b>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, marginTop: 4 }}>
                {people.map((p) => (
                  <span key={p.id} title={p.done ? (p.proxyName ? `${p.proxyName} làm hộ` : 'Đã hoàn thành') : 'Chưa hoàn thành'}
                    style={{ fontSize: 11, padding: '1px 7px', borderRadius: 999, whiteSpace: 'nowrap',
                      background: p.done ? 'color-mix(in srgb, var(--ok) 16%, transparent)' : 'color-mix(in srgb, var(--muted) 14%, transparent)',
                      color: p.done ? 'var(--ok)' : 'var(--muted)', fontWeight: p.done ? 600 : 400 }}>
                    {p.done ? '✓' : '○'} {p.name}{String(p.id) === myId ? ' (bạn)' : ''}{p.proxyName ? ` · ${p.proxyName} làm hộ` : ''}
                  </span>
                ))}
              </div>
            </div>
            {t.done ? (
              <div className="chattask-stat">🎉 Đã hoàn thành đầy đủ · ⏱ sau <b>{fmtTaskDuration(t.durationMs)}</b></div>
            ) : t.accepted ? (
              <div className="chattask-stat">✋ {t.acceptedByName} đã tiếp nhận · {fmtTaskDate(t.acceptedAt)}</div>
            ) : null}
            <div className="chattask-foot">
              {t.done
                ? <span className="chattask-st done">✓ Hoàn thành ({doneCount}/{total})</span>
                : t.accepted
                  ? <span className="chattask-st doing">● Đang thực hiện · {doneCount}/{total}</span>
                  : <span className="chattask-st waiting">🕓 Chờ tiếp nhận · {doneCount}/{total}</span>}
              <span className="chattask-actions">
                {!t.done && !t.accepted && (
                  <button type="button" className="btn xs warn" onClick={() => onAccept(t.id)}>✋ Tiếp nhận{!isAssignee ? ' hộ' : ''}</button>
                )}
                {isAssignee
                  ? (iMDone
                      ? <button type="button" className="btn xs ghost" onClick={() => onComplete(t.id, false)}>↩ Mở lại phần tôi</button>
                      : <button type="button" className="btn xs" onClick={() => onComplete(t.id, true)}>✓ Xong phần tôi</button>)
                  : (t.done
                      ? <button type="button" className="btn xs ghost" onClick={() => onComplete(t.id, false)}>↩ Mở lại</button>
                      : <button type="button" className="btn xs" onClick={() => onComplete(t.id, true)}>✓ Hoàn thành hộ</button>)}
                {canDel && <button type="button" className="chattask-del" title="Xoá công việc" onClick={() => onDelete(t.id)}>✕</button>}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
